import { ButtonBase } from '@mui/material';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';

interface OpenFullImageProps {
	onClick?: () => void;
}

export const OpenFullImage: React.FC<OpenFullImageProps> = ({ onClick }) => (
	<ButtonBase
		sx={(theme) => ({
			position: 'absolute',
			bottom: '18px',
			right: '70px',
			width: '26px',
			height: '26px',
			backgroundColor: '#000000',
			color: '#FFFFFF',
			opacity: '0.7',
			borderRadius: '13px',
			[theme.breakpoints.down(400)]: {
				bottom: '30px',
			},
			zIndex: 1001,
		})}
		onClick={onClick}
	>
		<OpenInFullIcon sx={{ width: '14px', height: '14px' }} />
	</ButtonBase>
);
